import getPrescriberAddress from 'utils/print/getPrescriberAddress';
import getPrescriberCity from 'utils/print/getPrescriberCity';
import getPrescriberState from 'utils/print/getPrescriberState';
import getPrescriberZip from 'utils/print/getPrescriberZip';

const getPrescriberFullAddress = ({ value, ...otherProps }) => {
  if (value !== null && value !== undefined) {
    return value;
  }
  const address = getPrescriberAddress(otherProps);
  const city = getPrescriberCity(otherProps);
  const state = getPrescriberState(otherProps);
  const zip = getPrescriberZip(otherProps);

  if (address && city && zip) {
    return `${address}, ${city}, ${state || ''} ${zip}`;
  }

  return null;
};

export default getPrescriberFullAddress;



// WEBPACK FOOTER //
// ./src/utils/print/getPrescriberFullAddress.js